<template lang="pug">
  .level.is-mobile.member-settings-form-controls
    .level-item
      WtButton(
        bold
        color="primary"
        size="large"
        @click.native="save"
        :disabled="disableSave"
        :loading="saveInProgress"
      ) SAVE
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "MemberSettingsFormControls",

  components: { WtButton },

  props: {
    disableSave: {
      type: Boolean,
      default: true
    },

    formData: {
      type: Object,
      required: true
    },

    keysToReset: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      saveInProgress: false
    };
  },

  computed: {
    ...mapGetters("members", ["member"])
  },

  methods: {
    ...mapActions("members", ["updateMember", "updateMemberCopy"]),
    ...mapActions(["snackBar"]),

    reset() {
      /**
       * in the event we need to handle any values
       * when reset is called
       * @event reset
       */
      this.$emit("reset");
      this.$emit("disable-save", true);

      if (this.keysToReset.length > 0) {
        this.keysToReset.forEach(item => {
          if (item.subKey) {
            this.updateMemberCopy({
              key: item.key,
              subKey: item.subKey,
              value: this.member[item.key][item.subKey]
            });
          } else {
            this.updateMemberCopy({
              key: item,
              value: this.member[item]
            });
          }
        });
      }
    },

    async save() {
      this.saveInProgress = true;
      // TODO refactor updateMember to throw in catch so we can use try/catch here
      const response = await this.updateMember({
        memberId: this.$auth.user().id,
        formData: this.formData
      });

      if (response.error) {
        const fields = response.error.fields;
        const firstErrorKey = Object.keys(fields)[0];
        this.$emit("form-error", fields[firstErrorKey][0]);
      } else {
        this.snackBar({ message: "Your settings have been updated." });
        this.$emit("disable-save", true);
      }

      this.saveInProgress = false;
    }
  }
};
</script>

<style lang="sass">
.member-settings-form-controls
  margin-bottom: 10px
  .button[disabled]
    background: $grey-light !important
    color: #FFFFFF !important
</style>
